import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';
import { RequisitionsScope } from '@recruitee/requisitions-types';
import type {
  RequisitionColumnId,
  RequisitionsGroupKind,
  RequisitionStatus,
} from '@recruitee/requisitions-types';

import { RequisitionsListViewType } from '../requisitions.types';
import { ColumnId, GroupKind, Scope } from './requisitions.analytics.types';

@Injectable()
export class RequisitionsAnalytics extends AnalyticsBase {
  public readonly namespace: string = 'Requisitions';
  public readonly requireViewContext: boolean = true;

  public trackRequestApproval(
    requisitionId: number,
    status: RequisitionStatus,
    hasCustomFields: boolean,
  ): void {
    this.track('Request', { requisitionId, status, hasCustomFields });
  }

  public trackApprove(requisitionId: number, currentStep: number): void {
    this.track('Approve', { requisitionId, currentStep });
  }

  public trackReject(requisitionId: number, currentStep: number): void {
    this.track('Reject', { requisitionId, currentStep });
  }

  public trackApproved(requisitionId: number): void {
    this.track('Approved', { requisitionId });
  }

  public trackCreateNew(type: 'blank' | 'duplicate'): void {
    this.track('CreateNew', { type });
  }

  public trackCreateJobFromRequisition(): void {
    this.track('CreateJobFromRequisition');
  }

  public trackGroupBy(type: RequisitionsGroupKind | null): void {
    this.track('GroupBy', { type: type ? GroupKind[type] : 'No group' });
  }

  public trackAdjustColumns(selectedField: RequisitionColumnId, enabled: boolean): void {
    this.track('AdjustColumns', { selectedField: ColumnId[selectedField], enabled });
  }

  public trackViewType(view: RequisitionsListViewType): void {
    const type = view === RequisitionsListViewType.Tiles ? 'Card' : 'Table';
    this.track('ChangeViewType', { type });
  }

  public trackChangeScope(requisitionsScope: RequisitionsScope): void {
    const scope =
      requisitionsScope === RequisitionsScope.Archived
        ? Scope[RequisitionsScope.Archived]
        : Scope[RequisitionsScope.Active];
    const type =
      requisitionsScope !== RequisitionsScope.Archived
        ? requisitionsScope === RequisitionsScope.Active
          ? 'All'
          : Scope[requisitionsScope]
        : undefined;

    this.track('ChangeFilterTab', {
      scope,
      ...(type ? { type } : {}),
    });
  }
}
